module.exports = __webpack_public_path__ + "img/step_back.69ffc4fe.svg";